"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const DeleteClusterModal = ({ name, onClose, onDelete, isDeleteInProgress, isOpen, }) => (React.createElement(react_core_1.Modal, { title: "Delete cluster", isOpen: isOpen, onClose: onClose, variant: react_core_1.ModalVariant.small, showClose: !isDeleteInProgress, actions: [
        React.createElement(react_core_1.Button, { "data-testid": "delete-cluster-submit", key: "confirm", variant: "danger", onClick: onDelete, isDisabled: isDeleteInProgress, isLoading: isDeleteInProgress }, "Delete"),
        React.createElement(react_core_1.Button, { key: "cancel", variant: "link", onClick: onClose, isDisabled: isDeleteInProgress }, "Cancel"),
    ] },
    "Are you sure you want to delete cluster ",
    name,
    " ?"));
exports.default = DeleteClusterModal;
//# sourceMappingURL=DeleteClusterModal.js.map